/** Leaf values produced by flattening nested audit event payloads. */
export type FlattenedAuditValue = string | number | boolean | null;

export const flattenComplexObject = (
  complexObject: Record<any, any>,
  prefix: string,
): Record<string, FlattenedAuditValue> => {
  // `typeof null === 'object'`, so a null (or any non-object) input would reach
  // `Object.entries(null)` and throw "Cannot convert undefined or null to object".
  if (complexObject === null || typeof complexObject !== 'object') {
    return {};
  }
  return Object.entries(complexObject).reduce<Record<string, FlattenedAuditValue>>(
    (accumulator, [propertyName, value]) => {
      const shouldRecurse = value !== null && typeof value === 'object';
      return {
        ...accumulator,
        ...(shouldRecurse
          ? flattenComplexObject(value, `${prefix}${propertyName}_`)
          : { [`${prefix}${propertyName}`]: typeof value === 'number' ? Number(value) : value }),
      };
    },
    {},
  );
};
